import { useDelivertyUser } from 'hooks/useDelivertyUser';
import { useCallback } from 'react';

export const useFetch = () => {
    const { userData, lastRefreshTime } = useDelivertyUser();
    const fetchMethod = useCallback(
        async ({ method, url, data }) => {
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    ...(userData?.token && { Authorization: `Bearer ${userData.token}` })
                },
                ...(data && { body: JSON.stringify(data) })
            });

            if (response.ok) {
                return response.json();
            }
            throw new Error(response.statusText);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [userData, lastRefreshTime]
    );
    return {
        fetchMethod,
        lastRefreshTime
    };
};
